<template>
  <div class="list-container">
    <div class="top-fix-area" ref="topFixArea">

      <div class="d-flex justify-content-between align-items-center">
        <h1 class="page-title">年間予定作業 - 月間作業予定</h1>
        <router-link :to="{ name: 'Home' }"> <!-- 業者情報詳細ページへのリンク -->
          <button type="button" class="btn btn-primary mx-1">ホーム</button>
        </router-link>
      </div>

      <div class="mb-2 d-flex justify-content-between align-items-center">
        <div>
          <router-link :to="{ name: 'TemporaryWorkCreate', params: { year: targetYear, month: targetMonth }, query: getSearchQuery() }"> <!-- 業者情報詳細ページへのリンク -->
            <button type="button" class="btn btn-sm btn-primary mx-1">臨時作業情報作成</button>
          </router-link>

          <button class="btn btn-sm btn-outline-secondary" @click="isSearchExpanded = !isSearchExpanded">
            {{ isSearchExpanded ? '検索条件を非表示' : '検索条件を表示' }}
          </button>
        </div>
      </div>
  
      <!-- 検索バーの追加 -->
      <SearchPanelWrapper :key="route.fullPath" v-model="isSearchExpanded" :getTableElement="() => tableWrapper?.$el || tableWrapper?.value" >
        <form class="search-container" style="background-color: #f8f9fa;" @submit.prevent="searchAllSchedules"> <!-- 背景色を薄く設定 -->
          <div class="d-flex flex-wrap align-items-center">
  
            <div class="d-flex align-items-center my-2 me-3">
              <label class="col-form-label me-2">作業予定年月</label>

              <!-- From -->
              <div class="d-flex align-items-center me-2">
                <select class="form-select me-1" v-model="searchYearFrom" style="min-width: 120px">
                  <option value="" selected>年</option>
                  <option v-for="year in years" :key="year" :value="year">{{ year }}年</option>
                </select>
                <select class="form-select" v-model="searchMonthFrom" style="min-width: 100px">
                  <option value="" selected>月</option>
                  <option v-for="month in months" :key="month" :value="month">{{ month }}月</option>
                </select>
              </div>

              <label class="col-form-label me-2">〜</label>

              <!-- To -->
              <div class="d-flex align-items-center">
                <select class="form-select me-1" v-model="searchYearTo" style="min-width: 120px">
                  <option value="" selected>年</option>
                  <option v-for="year in years" :key="year" :value="year">{{ year }}年</option>
                </select>
                <select class="form-select" v-model="searchMonthTo" style="min-width: 100px">
                  <option value="" selected>月</option>
                  <option v-for="month in months" :key="month" :value="month">{{ month }}月</option>
                </select>
              </div>
            </div>
  
            <div class="d-flex align-items-center mb-2 me-2">
              <div class="me-2">
                <label for="searchCustomerName" class="col-form-label">顧客名</label>
              </div>
              <div class="me-2">
                <CustomerSelectBox
                  v-model="searchCustomerName"
                  :options="customers"
                  placeholder="顧客名で検索"
                  :formatter="c => c.customer_nm"
                />
              </div>
            </div>
  
            <div class="d-flex align-items-center mb-2 me-2">
              <div class="me-2">
                <label for="searchBuildingName" class="col-form-label">建物名</label>
              </div>
              <div class="me-2">
                <BuildingSelectBox
                  v-model="searchBuildingName"
                  :options="buildings"
                  placeholder="建物名で検索"
                  :formatter="b => b.building_nm"
                />
              </div>
            </div>
  
            <div class="d-flex align-items-center mb-2 me-2">
              <div class="me-2">
                <label for="searchBusinessClassificationName" class="col-form-label">業務区分</label>
              </div>
              <div class="me-2">
                <select id="searchBusinessClassificationName" class="form-select" v-model="searchBusinessClassificationName" placeholder="業務区分で検索">
                  <option value="" selected>選択してください</option> <!-- placeholder -->
                  <option v-for="businessClassification in businessClassifications" :key="businessClassification.id" :value="businessClassification.id">{{ businessClassification.business_classification_nm }}</option>
                </select>
              </div>
            </div>
  
            <div class="d-flex align-items-center mb-2 me-2">
              <div class="me-2">
                <label for="searchWorkContent" class="col-form-label">業務内容</label>
              </div>
              <div class="col-auto">
                <input type="text" id="searchWorkContent" class="form-control" v-model="searchWorkContent" placeholder="業務内容で検索">
              </div>
            </div>
  
            <div class="d-flex align-items-center mb-2 me-2">
              <div class="me-2">
                <label for="searchVendorName" class="col-form-label">協力会社の有無</label>
              </div>
              <div class="me-2">
                <select id="searchIsPartnerCompany" class="form-select" v-model="searchIsPartnerCompany" placeholder="協力会社の有無で検索">
                  <option value="" selected>選択してください</option> <!-- placeholder -->
                  <option v-for="isPartnerCompany in isPartnerCompanies" :key="isPartnerCompany.id" :value="isPartnerCompany.id">{{ isPartnerCompany.val }}</option>
                </select>
              </div>
            </div>
  
            <div class="d-flex align-items-center mb-2 me-2">
              <div class="me-2">
                <label for="searchVendorName" class="col-form-label">協力会社名</label>
              </div>
              <div class="me-2">
                <VendorSelectBox
                  v-model="searchVendorName"
                  :options="vendors"
                  placeholder="業者名で検索"
                  :formatter="v => v.vendor_nm"
                />
              </div>
            </div>

            <!-- 担当者検索 -->
            <div class="d-flex align-items-center my-2 me-3">
              <div class="col-auto">
                <UserSelectBox
                  v-model="searchUserName"
                  :options="users"
                  placeholder="担当者名で検索"
                  :formatter="v => v.name"
                />
              </div>
            </div>
  
            <div class="col-auto">
              <button type="submit" class="btn btn-primary mx-1">検索</button>
              <button type="button" class="btn btn-secondary mx-1" @click="searchResetAllSchedules">クリア</button>
            </div>
          </div>
        </form>
      </SearchPanelWrapper>
    </div>

    <div class="d-flex justify-content-end" ref="paginationContainer">
      <Pagination
        :currentPage="currentPage"
        :totalPages="totalPages"
        @change-page="handleChangePage"
      />
    </div>

    <div class="table-wrapper" ref="tableWrapper">
      <table class="table table-bordered table-hover">
        <thead>
          <tr>
            <th class="text-nowrap bg-tb-header th-sticky">顧客名</th>
            <th class="text-nowrap bg-tb-header th-sticky">建物名</th>
            <th class="text-nowrap bg-tb-header th-sticky">業務区分</th>
            <th class="text-nowrap bg-tb-header th-sticky">業務内容</th>
            <th class="text-nowrap bg-tb-header th-sticky">年月</th>
            <th class="text-nowrap bg-tb-header th-sticky">作業予定日</th>
            <th class="text-nowrap bg-tb-header th-sticky">担当者</th>
            <th class="text-nowrap bg-tb-header th-sticky">金額</th>
            <th class="text-nowrap bg-tb-header th-sticky">協力会社</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="monthlyAnnualSchedule in monthlyAnnualSchedules" :key="monthlyAnnualSchedule.id">
            <td class="multiline-text">{{ monthlyAnnualSchedule.t_building_work_annual_schedule.m_customer.customer_nm }}</td>
            <td class="text-nowrap">
              <router-link
                v-if="buildAnnualScheduleListTo(monthlyAnnualSchedule)"
                :to="buildAnnualScheduleListTo(monthlyAnnualSchedule)"
                target="_blank"
                rel="noopener noreferrer"
                class="building-link"
                title="年間予定表を別タブで開く"
              >
                {{ monthlyAnnualSchedule.t_building_work_annual_schedule.m_building.building_nm }}
              </router-link>
              <span v-else>{{ monthlyAnnualSchedule.t_building_work_annual_schedule.m_building.building_nm }}</span>
            </td>
            <td class="text-nowrap">{{ monthlyAnnualSchedule.t_building_work_annual_schedule.m_business_classification.business_classification_nm }}</td>
            <td class="text-nowrap">{{ monthlyAnnualSchedule.t_building_work_annual_schedule.work_content }}</td>
            <td class="text-nowrap">{{ monthlyAnnualSchedule.work_year }}年{{ monthlyAnnualSchedule.work_month }}月</td>
            <td class="text-nowrap">{{ formatYearMonthDay(monthlyAnnualSchedule.work_plan_dt) }}</td>
            <td class="text-nowrap">{{ monthlyAnnualSchedule.user?.name }}</td>
            <td class="text-nowrap text-end">{{ formatCurrency(monthlyAnnualSchedule.bill_amount) }}</td>
            <td class="text-nowrap">
              <ul v-if="monthlyAnnualSchedule.t_building_work_schedule_detail_vendors" class="ps-3 mb-0">
                <template v-for="vendor in monthlyAnnualSchedule.t_building_work_schedule_detail_vendors" :key="vendor.id">
                  <li class="text-nowrap">{{ vendor.m_vendor.vendor_nm }}</li>
                </template>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch, watchEffect } from 'vue';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
import {
  getSelectBoxCustomers,
  getSelectBoxBuildings,
  getBusinessClassifications,
  getSelectBoxVendors,
  getSelectBoxUsers,
  getMonthlyAnnualSchedules
} from '@/api/axios';
import CustomerSelectBox from '@/components/searchSelectBoxes/CustomerSelectBox.vue';
import BuildingSelectBox from '@/components/searchSelectBoxes/BuildingSelectBox.vue';
import VendorSelectBox from '@/components/searchSelectBoxes/VendorSelectBox.vue';
import UserSelectBox from '@/components/searchSelectBoxes/UserSelectBox.vue';
import SearchPanelWrapper from '@/components/searchPanels/SearchPanelWrapper.vue';
import Pagination from '@/components/shared/Pagination.vue';

export default {
  components: {
    CustomerSelectBox,
    BuildingSelectBox,
    VendorSelectBox,
    UserSelectBox,
    SearchPanelWrapper,
    Pagination
  },
  setup() {
    const title = ref('年間作業一覧');

    watchEffect(() => {
      document.title = title.value;
    });

    const router = useRouter();
    const route = useRoute();
    const monthlyAnnualSchedules = ref([]);
    const buildings = ref([]);
    const customers = ref([]);
    const businessClassifications = ref([]);
    const years = ref([]);
    const months = ref([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
    const targetYear = ref('');
    const targetMonth = ref('');
    const isPartnerCompanies = ref([{id: 1, val: 'あり'}, {id: 2, val: 'なし'}]);
    const vendors = ref([]);
    const users = ref([]);

    // 現在の年月を取得
    const currentDate = new Date()
    const currentYear = currentDate.getFullYear();
    for (let i = currentYear - 5; i <= currentYear + 5; i++) {
      years.value.push(i);
    }

    targetYear.value = route.query.year ? parseInt(route.query.year, 10) : '';
    targetMonth.value = route.query.month ? parseInt(route.query.month, 10) : '';

    const isSearchExpanded = ref(true);
    // 検索用のデータプロパティ
    const searchYearFrom = ref('');
    const searchMonthFrom = ref('');
    const searchYearTo = ref('');
    const searchMonthTo = ref('');
    const searchCustomerName = ref('');
    const searchBuildingName = ref('');
    const searchBusinessClassificationName = ref('');
    const searchWorkContent = ref('');
    const searchIsPartnerCompany = ref('');
    const searchVendorName = ref('');
    const searchUserName = ref('');

    const parseQueryNumber = (value) => {
      if (value === undefined || value === null || value === '') return '';
      const parsed = parseInt(value, 10);
      return Number.isNaN(parsed) ? '' : parsed;
    };

    const parsePage = (value) => {
      const parsed = parseInt(value, 10);
      return Number.isNaN(parsed) || parsed < 1 ? 1 : parsed;
    };

    const ymToNumber = (year, month) => {
      if (!year || !month) return null;
      return Number(year) * 100 + Number(month);
    };

    const setDefaultSearchYearMonthRange = () => {
      const fromDate = new Date();
      const toDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), 1);
      toDate.setMonth(toDate.getMonth() + 3);

      searchYearFrom.value = fromDate.getFullYear();
      searchMonthFrom.value = fromDate.getMonth() + 1;
      searchYearTo.value = toDate.getFullYear();
      searchMonthTo.value = toDate.getMonth() + 1;
    };

    // ▼▼ 共通：検索条件をそのまま query として返す ▼▼
    const getSearchQuery = () => ({
      monthly_schedule_year_from: searchYearFrom.value,
      monthly_schedule_month_from: searchMonthFrom.value,
      monthly_schedule_year_to: searchYearTo.value,
      monthly_schedule_month_to: searchMonthTo.value,
      monthly_schedule_customer_id: searchCustomerName.value,
      monthly_schedule_building_id: searchBuildingName.value,
      monthly_schedule_business_classification_id: searchBusinessClassificationName.value,
      monthly_schedule_work_content: searchWorkContent.value,
      monthly_schedule_is_partner_company: searchIsPartnerCompany.value,
      monthly_schedule_vendor_id: searchVendorName.value,
      monthly_schedule_user_id: searchUserName.value,
      monthly_schedule_page: currentPage.value || 1
    });

    // ページネーション
    const currentPage = ref(1);
    const totalPages = ref(50); // トータルページ数を管理するためのプロパティ

    // From > To の場合は To を From に補正
    watch([searchYearFrom, searchMonthFrom, searchYearTo, searchMonthTo], () => {
      const from = ymToNumber(searchYearFrom.value, searchMonthFrom.value);
      const to = ymToNumber(searchYearTo.value, searchMonthTo.value);

      if (from && to && from > to) {
        searchYearTo.value = searchYearFrom.value;
        searchMonthTo.value = searchMonthFrom.value;
      }
    });

    const fetchAllSchedules = async (page = 1) => {
      try {
        const response = await getMonthlyAnnualSchedules({
          year_from: searchYearFrom.value,
          month_from: searchMonthFrom.value,
          year_to: searchYearTo.value,
          month_to: searchMonthTo.value,
          customer_id: searchCustomerName.value,
          building_id: searchBuildingName.value,
          business_classification_id: searchBusinessClassificationName.value,
          work_content: searchWorkContent.value,
          is_partner_company: searchIsPartnerCompany.value,
          vendor_id: searchVendorName.value,
          user_id: searchUserName.value,
          page: page
        });
        monthlyAnnualSchedules.value = response.data.annual_schedule_details;
        totalPages.value = response.data.meta.total_pages;
        currentPage.value = response.data.meta.current_page;
      } catch (error) {
        console.error('全建物年間予定作業情報ーデータの取得に失敗しました:', error);
      }

      // 顧客情報（検索用）
      try {
        const response = await getSelectBoxCustomers();
        customers.value = response.data;
      } catch (error) {
        console.error('顧客情報データの取得に失敗しました:', error);
      }

      // 建物情報（検索用）
      try {
        const response = await getSelectBoxBuildings();
        buildings.value = response.data;
      } catch (error) {
        console.error('建物情報データの取得に失敗しました:', error);
      }

      // 業務区分（検索用）
      try {
        const response = await getBusinessClassifications();
        businessClassifications.value = response.data;
      } catch (error) {
        console.error('業務区分情報データの取得に失敗しました:', error);
      }

      // 業者（検索用）
      try {
        const response = await getSelectBoxVendors();
        vendors.value = response.data;
      } catch (error) {
        console.error('業者情報データの取得に失敗しました:', error);
      }

      // ユーザ情報（検索用）
      try {
        const response = await getSelectBoxUsers();
        users.value = response.data;
      } catch (error) {
        console.error('ユーザ情報ーデータの取得に失敗しました:', error);
      }
    };

    const handleChangePage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        fetchAllSchedules(page);

        const q = getSearchQuery();
        q.monthly_schedule_page = page;

        router.replace({
          path: '/monthly-annual-work-schedules',
          query: q
        });

        // スクロールを tableWrapper のトップへ
        if (tableWrapper.value) {
          tableWrapper.value.scrollTop = 0;
        }
      }
    };

    // 検索処理
    const searchAllSchedules = async () => {
      await fetchAllSchedules(1); // 検索時は1ページ目に戻す

      const q = getSearchQuery();
      q.monthly_schedule_page = 1;

      router.push({
        path: '/monthly-annual-work-schedules',
        query: q,
      });
    };

    // リセット処理
    const searchResetAllSchedules = async () => {
      searchYearFrom.value = ''; // 年検索条件をクリア
      searchMonthFrom.value = ''; // 月検索条件をクリア
      searchYearTo.value = ''; // 年検索条件をクリア
      searchMonthTo.value = ''; // 月検索条件をクリア
      searchCustomerName.value = '';
      searchBuildingName.value = '';
      searchBusinessClassificationName.value = '';
      searchWorkContent.value = '';
      searchIsPartnerCompany.value = '';
      searchVendorName.value = '';
      searchUserName.value = '';

      await fetchAllSchedules(1);

      const q = getSearchQuery();
      q.monthly_schedule_page = 1;

      router.replace({
        path: '/monthly-annual-work-schedules',
        query: q,
      });
    };

    // Format currency
    const formatCurrency = (value) => {
      if (value) {
        return new Intl.NumberFormat('ja-JP', {
          style: 'currency',
          currency: 'JPY',
        }).format(value);
      }
      return '¥0';
    };

    const formatYearMonthDay = (dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
    };

    const buildAnnualScheduleListTo = (monthlyAnnualSchedule) => {
      const buildingId = monthlyAnnualSchedule?.t_building_work_annual_schedule?.m_building_id;
      const workYear = monthlyAnnualSchedule?.work_year;
      const workMonth = monthlyAnnualSchedule?.work_month;
      const contractDt = monthlyAnnualSchedule?.t_building_work_annual_schedule?.m_building?.contract_dt;
      const contractMonth = contractDt ? Number(String(contractDt).slice(5, 7)) : null;

      if (!buildingId || !workYear || !workMonth) return null;

      const startMonth = contractMonth && contractMonth >= 1 && contractMonth <= 12
        ? contractMonth
        : 1;
      const startYear = Number(workMonth) >= Number(startMonth)
        ? Number(workYear)
        : Number(workYear) - 1;

      return {
        name: 'AnnualWorkScheduleList',
        params: {
          building_id: buildingId,
          start_month: `${startYear}-${startMonth}-1`
        },
        query: route.query
      };
    };

    // テーブルの高さの動的な設定
    const topFixArea = ref(null);
    const tableWrapper = ref(null);
    const paginationContainer = ref(null);

    // ▼▼▼ クエリパラメータから検索条件を復元 ▼▼▼
    onMounted(async () => {
      const q = route.query;
      const monthlyScheduleQueryKeys = [
        'monthly_schedule_year_from',
        'monthly_schedule_month_from',
        'monthly_schedule_year_to',
        'monthly_schedule_month_to',
        'monthly_schedule_customer_id',
        'monthly_schedule_building_id',
        'monthly_schedule_business_classification_id',
        'monthly_schedule_work_content',
        'monthly_schedule_is_partner_company',
        'monthly_schedule_vendor_id',
        'monthly_schedule_user_id',
        'monthly_schedule_page'
      ];
      const hasMonthlyScheduleQuery = monthlyScheduleQueryKeys.some((key) =>
        Object.prototype.hasOwnProperty.call(q, key)
      );

      if (hasMonthlyScheduleQuery) {
        searchYearFrom.value = parseQueryNumber(q.monthly_schedule_year_from);
        searchMonthFrom.value = parseQueryNumber(q.monthly_schedule_month_from);
        searchYearTo.value = parseQueryNumber(q.monthly_schedule_year_to);
        searchMonthTo.value = parseQueryNumber(q.monthly_schedule_month_to);
        searchCustomerName.value = q.monthly_schedule_customer_id || '';
        searchBuildingName.value = q.monthly_schedule_building_id || '';
        searchBusinessClassificationName.value = q.monthly_schedule_business_classification_id || '';
        searchWorkContent.value = q.monthly_schedule_work_content || '';
        searchIsPartnerCompany.value = q.monthly_schedule_is_partner_company || '';
        searchVendorName.value = q.monthly_schedule_vendor_id || '';
        searchUserName.value = q.monthly_schedule_user_id || '';
        currentPage.value = parsePage(q.monthly_schedule_page);
      } else {
        setDefaultSearchYearMonthRange();
        currentPage.value = 1;

        await router.replace({
          path: '/monthly-annual-work-schedules',
          query: {
            ...q,
            ...getSearchQuery(),
            monthly_schedule_page: 1
          }
        });
      }

      fetchAllSchedules(currentPage.value);
    });

    return {
      title,
      route,
      monthlyAnnualSchedules,
      buildings,
      customers,
      businessClassifications,
      years,
      months,
      targetYear,
      targetMonth,
      formatCurrency, 
      isPartnerCompanies,
      vendors,
      users,
      searchCustomerName,
      searchBuildingName,
      searchBusinessClassificationName,
      searchWorkContent,
      searchYearFrom,
      searchMonthFrom,
      searchYearTo,
      searchMonthTo,
      searchIsPartnerCompany,
      searchVendorName,
      searchUserName,
      formatYearMonthDay,
      buildAnnualScheduleListTo,
      getSearchQuery,
      currentPage,
      totalPages,
      handleChangePage,
      isSearchExpanded,
      topFixArea,
      tableWrapper,
      paginationContainer,
      searchAllSchedules,
      searchResetAllSchedules
    };
  }
};
</script>

<style scoped>
/* 検索スライド開閉のトランジション */
.accordion-enter-active,
.accordion-leave-active {
  overflow: hidden;
}

.building-item {
  border: 1px solid #ddd;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.building-item:hover {
  background-color: #f5f5f5;
}

/* テーブルラッパーのスタイル */
.table-wrapper {
  background: #FFFFFF;
  border: 1px solid #BBBBBB;
  margin-bottom: 0;
  height: 100%;
}

.building-link {
  color: #0d6efd;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.table-wrapper table{
  background: #FFFFFF;
  border: 1px solid #BBBBBB;
  margin-bottom: 0;
}

.table-wrapper thead th {
  position: sticky;
  top: 0;
  background: #003366 !important; /* 背景色を設定し、スクロール中に背景が透けるのを防ぐ */
  color: #fff !important;
  z-index: 10;
}

.table-wrapper .th-sticky{
  z-index: 100 !important;
}

table th,
table td{
  border: 1px solid #BBBBBB;
  font-size: 14px;
}

table th.bg-tb-header{
  background-color: #003366;
  color: #fff;
}

table .schedule-data-area td.bg-tb-side-header{
  background-color: #f0f8ff;
}

table .month-breakdown-area td.bg-tb-side-header,
table .month-tax-area td.bg-tb-side-header{
  background-color: #fafad2;
}

table .month-breakdown-area{
  border-top: 3px dotted #BBBBBB;
}

table .month-tax-area{
  border-bottom: 3px dotted #BBBBBB;
}

.vendor-info-table{
  width: 100%;
  border: none !important;
}
.vendor-info-table th,
.vendor-info-table td{
  padding: 4px 8px;
}
.vendor-info-table th{
  background-color: #e9f4f9;
  font-weight: normal;
}
</style>
